export const EMPTY: string = 'Empty';
export const SHORT: string = 'Too short';
export const WEAK: string = 'Weak';
export const MEDIUM: string = 'Medium';
export const STRONG: string = 'Strong';
